import { useCallback, useEffect, useRef } from 'react';
import { ReactTags, TagSuggestion, Tag, ListBoxRenderer } from 'react-tag-autocomplete';

import  '@/css/global/TextInputs/AutoCompleteWithTags.scss';

interface IAutoCompleteWithTags {
    id?: string,
    selected: Tag[],
    setSelected: (tags: Tag[]) => void,
    suggestions: TagSuggestion[],
    setSuggestions:  (tags: TagSuggestion[]) => void
    isLoading?: boolean
    setIsLoading?: (val: boolean) => void
    input: string,
    noOptionsText: string,
    placeholderText: string,
    setInput: (val: string) => void 
    customOnAddCb?:(...args: any) => void
    customOnDeletedCb?:(...args: any) => void
    customOnExpand?:() => void
    closeOnScrollTarget?: HTMLElement
    isDisabled?:boolean,
    customListBox?: ListBoxRenderer
}


function CustomOption({ children, classNames, option, ...optionProps }:any) {
    const classes = [
      classNames.option,
      option.active ? 'is-active' : '',
      option.selected ? 'is-selected' : '',
    ]

    useEffect(() => {
        if(option.active) {
            /*
                scroll into view moves all scrollable elements, makes this super janky
                so we remember the windows currect scroll position, scroll the element
                into view, then reset the windows scroll position, this happens so fast
                that there is no visivle jank
            */
            const y = window.scrollY;
            const x = window.scrollX;
            const activeElement = document.querySelector('.custom-select-option.is-active');
            activeElement?.scrollIntoView?.({
                behavior: "smooth",
                block: "end",
                inline: "nearest"
            })
            window?.scroll?.(x, y);
        }  
    },[option.active])
  
    return (
      <div className={`custom-select-option ${classes.join(' ')}`} {...optionProps}>
        {children}
      </div>
    )
  }

const AutocompleteWithTags = ({
    id,
    selected,
    suggestions,
    noOptionsText,
    placeholderText,
    setInput,
    setSelected,
    setSuggestions,
    setIsLoading,
    customOnAddCb,
    customOnDeletedCb,
    customOnExpand,
    closeOnScrollTarget,
    isDisabled,
    customListBox
}: IAutoCompleteWithTags) => {

    const api = useRef<any>(null) 

    useEffect(() => {
        function close() {
            api?.current?.listBox?.collapse();
        }

        closeOnScrollTarget && closeOnScrollTarget.addEventListener('scroll', close)

        return () => {
            closeOnScrollTarget && closeOnScrollTarget.removeEventListener('scroll', close)

        }
    }, [])

    const onAdd = useCallback((newTag: any) => {
        setSelected([...selected, newTag])
        setSuggestions([])
        customOnAddCb?.()
    }, [selected])
    
    
    const onDelete = useCallback((index: any) => {
        setSelected(selected.filter((_, i) => i !== index))
        customOnDeletedCb?.();
    },[selected])

    const onInput = useCallback((value: string) => {
        setIsLoading?.(true);
        setInput(value)
    },[selected])

    return (<div className="auto-complete-tags-wrapper">    
            <ReactTags 
                id={id}
                ref={api}
                selected={selected}
                suggestions={suggestions}
                onAdd={onAdd}
                onInput={onInput}
                onDelete={onDelete}
                noOptionsText={noOptionsText}
                placeholderText={placeholderText}
                onExpand={customOnExpand}
                isDisabled={isDisabled}
                renderListBox={customListBox}
                renderOption={customListBox ? CustomOption : undefined}
            />
    </div>)
}

export default AutocompleteWithTags